import {
  CANCEL_BID,
  CANCEL_BID_ERROR,
  CANCEL_BID_HIDE_DIALOG_SUCCESS,
  CANCEL_BID_SHOW_DIALOG_SUCCESS,
  CANCEL_BID_SUCCESS
} from './CancelBidSellerDialog.actions'

const initialState = {
  bidId: null,
  errors: [],
  loading: false,
  open: false
}

/**
 * The cancelBidSellerDialog reducer.
 */
const cancelBidSellerDialogReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case CANCEL_BID_HIDE_DIALOG_SUCCESS: {
      return { ...state, bidId: null, open: false }
    }
    case CANCEL_BID_SHOW_DIALOG_SUCCESS: {
      return { ...state, bidId: payload.bidId, open: true }
    }
    case CANCEL_BID: {
      return { ...state, loading: true, errors: [] }
    }
    case CANCEL_BID_ERROR: {
      return { ...state, loading: false, errors: payload.error }
    }
    case CANCEL_BID_SUCCESS: {
      return { ...state, loading: false, errors: [], bidId: null, open: false }
    }
    default:
      return state
  }
}

export default cancelBidSellerDialogReducer
